import React from 'react';
import QRCode from "qrcode.react";
import Typography from "@material-ui/core/Typography";
import { Grid, Button, makeStyles } from "@material-ui/core";

//Update log
// FB 6025 BR   04/26/2022    PE - Import Photos through QR code scan from smartphone
// FB 6985 DK   06/20/2023    QR code link should be dynamic

export default function Importphotos(props) {
  var decodedAppt_n = Buffer.from(props.match.params.apptId, "base64").toString();
  var decodedDocType = Buffer.from(props.match.params.docType, "base64").toString();
  var encodedDocType = Buffer.from(decodedDocType).toString('base64');
  //FB 6985
  const url = window.location.origin + "/appointment/Capturephotos/" + decodedAppt_n + "/" + encodedDocType;

  return (
    <div>
      <Grid
        lg={12}
        md={12}
        sm={12}
        xs={12}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography variant="h6" component="legend">
          Scan the below QR code to upload photos and close this tab once the file(s) uploaded
        </Typography>
      </Grid>
      <br />
      <br />
      <Grid
        lg={12}
        md={12}
        sm={12}
        xs={12}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <QRCode value={url} />
      </Grid>
    </div>
  );
}